import { render, staticRenderFns } from "./ImprintPage.vue?vue&type=template&id=47ce086b&scoped=true"
import script from "./ImprintPage.vue?vue&type=script&lang=js"
export * from "./ImprintPage.vue?vue&type=script&lang=js"
import style0 from "./ImprintPage.vue?vue&type=style&index=0&id=47ce086b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce086b",
  null
  
)

export default component.exports